export const convertHourToDate = hourToConverted => {
	const now = new Date();
	const hourArr = hourToConverted.split(':');
	return new Date(now.getFullYear(), now.getMonth(), now.getDate(), hourArr[0], hourArr[1]);
}

export const convertArrHourToStrHour = arrHour => {
	return String(arrHour[0]).padStart(2, '0') + 
	(arrHour[1] ? ':' + arrHour[1].padStart(2, '0'): ":00" ) + 
	(arrHour[2] ? ':' + arrHour[2].padStart(2, '0'): "" );
}
